/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from '@ember/object';
import { next } from '@ember/runloop';
import Component from '@glimmer/component';
import FormValidations from 'cio/utils/form-validations';
import SqlImportDatabase from 'cio/models/sql-import-database';

interface SqlImportsCreateDatabaseBigqueryArgs {
  database?: SqlImportDatabase;
  readOnly?: boolean;
  validations: FormValidations;
}

export default class SqlImportsCreateDatabaseBigquery extends Component<SqlImportsCreateDatabaseBigqueryArgs> {
  @action
  handlePasswordChange() {
    next(() => {
      this.args.validations.validateAttribute('password');
    });
  }

  @action
  onProjectIdChange(projectId: string) {
    this.args.database?.set('projectId', projectId);
    this.args.validations.validateAttribute('projectId');
  }
}
